import { FragmentDeleteDialog } from '@app/modules/fragments/screens/delete/FragmentDeleteDialog';
import { Station } from '@mi-front/core';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useFragment } from '../hooks/useFragment';

interface FragmentViewOverflowActionsProps {
  station: Station;
}

/**
 * Overflow menu (three dots) for fragment view header: hosts secondary actions such as delete.
 */
export function FragmentViewOverflowActions({ station }: FragmentViewOverflowActionsProps) {
  const { fragment } = useFragment();
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const menuOpen = Boolean(menuAnchor);

  function handleOpenMenu(event: MouseEvent<HTMLElement>) {
    setMenuAnchor(event.currentTarget);
  }

  function handleCloseMenu() {
    setMenuAnchor(null);
  }

  function handleRequestDelete() {
    handleCloseMenu();
    setDeleteDialogOpen(true);
  }

  return (
    <>
      <IconButton size="small" color="secondary" onClick={handleOpenMenu}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={menuAnchor} open={menuOpen} onClose={handleCloseMenu}>
        <MenuItem onClick={handleRequestDelete} sx={{ color: 'error.main' }}>
          <ListItemIcon sx={{ color: 'inherit' }}>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            <FormattedMessage id="common.actions.delete" defaultMessage="Eliminar" />
          </ListItemText>
        </MenuItem>
      </Menu>
      <FragmentDeleteDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        station={station}
        fragment={fragment}
      />
    </>
  );
}
